import React from 'react';

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import DropdownMenu, { DropdownItem } from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';
import { Box, xcss } from '@atlaskit/primitives';

import { messages as commonMessages } from '../../../../../../../common/messages';

import { messages } from './messages';
import { type RotationProps } from './types';

const nameStyles = xcss({
	marginTop: '0',
	marginRight: 'auto',
	marginBottom: '0',
	marginLeft: 'space.150',
	minWidth: '0',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

const optionStyles = xcss({
	marginTop: '0',
	marginRight: 'space.050',
	marginBottom: '0',
	marginLeft: 'space.150',
	minWidth: '32px',
	maxWidth: '32px',
});

const Rotation = ({ id, name, onClone, onDelete, onEdit, isDisabled }: RotationProps) => {
	const intlApi = useIntl();

	return (
		<>
			<Box title={name} xcss={nameStyles}>
				{name}
			</Box>

			<Box xcss={optionStyles}>
				<DropdownMenu<HTMLButtonElement>
					trigger={({ triggerRef, ...props }) => (
						<IconButton
							{...props}
							label={intlApi.formatMessage(messages.actionsForRotation, {
								rotationName: name,
							})}
							id={`${id}-rotation-options`}
							isDisabled={isDisabled}
							appearance="subtle"
							icon={MoreIcon}
							ref={triggerRef}
						/>
					)}
					shouldRenderToParent
				>
					<DropdownItem onClick={onEdit}>{intlApi.formatMessage(commonMessages.edit)}</DropdownItem>
					<DropdownItem onClick={onClone}>
						{intlApi.formatMessage(commonMessages.duplicate)}
					</DropdownItem>
					<DropdownItem onClick={onDelete}>
						{intlApi.formatMessage(commonMessages.delete)}
					</DropdownItem>
				</DropdownMenu>
			</Box>
		</>
	);
};

export { Rotation };
